import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ClockCounterClockwise, CaretDown } from "@phosphor-icons/react";

export const PriorCasesCard = ({ conversationId, reopenedAt }) => {
  const [summary, setSummary] = useState(null);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    let alive = true;
    setSummary(null);
    api.get(`/conversations/${conversationId}/prior-summary`)
      .then(({ data }) => alive && setSummary(data.summary || ""))
      .catch(() => alive && setSummary(""));
    return () => { alive = false; };
  }, [conversationId, reopenedAt]);

  if (summary === "") return null;
  return (
    <div className="mx-4 mt-3 rounded-lg border border-sky-500/30 bg-sky-500/5 text-xs" data-testid="prior-cases-card">
      <button type="button" onClick={() => setOpen((v) => !v)} className="w-full flex items-center gap-2 px-3 py-2 text-left"
        data-testid="prior-cases-toggle">
        <ClockCounterClockwise size={14} className="text-sky-600" />
        <span className="font-semibold text-sky-700">Casos anteriores de este cliente</span>
        <span className="text-muted-foreground">· reabierta {new Date(reopenedAt).toLocaleString("es-DO")}</span>
        <CaretDown size={12} className={`ml-auto transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-3 pb-3 whitespace-pre-line text-foreground/80 leading-relaxed" data-testid="prior-cases-summary">
          {summary === null ? "Generando resumen…" : summary}
        </div>
      )}
    </div>
  );
};

export default PriorCasesCard;
